import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStorePickupOptions } from './actions';
import { useTokenCache } from '@@client/lib/hooks';
export default function loadStorePickupOptions() {
  var checkoutStore = useSelector(function (state) {
    return state.checkout;
  });
  var dispatch = useDispatch();
  var tokenCache = useTokenCache();
  useEffect(function () {
    // already doing, no need to fetch again
    if (checkoutStore.storePickupOptions.doing) return;
    dispatch(getStorePickupOptions(tokenCache));
  }, [checkoutStore.info.checkoutToken]);
  return null;
}